import { FC } from 'react';
import { HELP_ROUTE } from 'components/help/constants';
import ELEMENT from 'common/element';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Link from 'components/common/Link/Link';
import BaseTable from 'components/common/BaseTable/BaseTable';
import { MOCK_HEADERS, MOCK_ROW_VALUES } from '../../consts';

const GettingStartedWithPQ: FC = () => (
  <div className="PowerQueries__MockContainer">
    Getting started with PowerQueries:
    <ul className="PowerQueries__IntroList">
      <li>
        {'Use '}
        <kbd>Cmd</kbd>
        {' + '}
        <kbd>Enter</kbd>
        {' to execute the query, and '}
        <kbd>Enter</kbd>
        {' to add a new line '}
      </li>
      <li>
        {'Read the '}
        <Link className="link" href={HELP_ROUTE.HELP_POWER_QUERIES} openInNewTab>
          Query Language Documentation
        </Link>
      </li>
      <li> Or start by using the standard search language to select events to analyze</li>
      <li>Click the links below the edit area to add processing commands, or type them yourself</li>
    </ul>
    Here&apos;s an example that determines the rate of 404s by URL path, sorted by the worst offenders:
    <div className="PowerQueries__QueryExampleContainer">
      <div className="PowerQueries__CodeContainer" data-test-id={ELEMENT.powerQueryExampleCode}>
        <code className="CodeExample">
          dataset = &quot;accesslog&quot;
          <br />
          | group requests = count(), errors = count(status == 404) by uriPath
          <br />
          | let rate = errors / requests
          <br />
          | filter rate &gt; 0.01
          <br />| sort -rate
        </code>
      </div>
      <div className="PowerQueries__ArrowContainer" data-test-id={ELEMENT.powerQueryExampleArrow}>
        <ArrowForward />
      </div>
      <div data-test-id={ELEMENT.powerQueryExampleResults}>
        <BaseTable rowHeight={31} width={360} height={193} columns={MOCK_HEADERS} data={MOCK_ROW_VALUES} />
      </div>
    </div>
  </div>
);

export default GettingStartedWithPQ;
